import { render, staticRenderFns } from "./ModerationDuel.vue?vue&type=template&id=bd4ddd4e&lang=pug"
import script from "./ModerationDuel.vue?vue&type=script&lang=js"
export * from "./ModerationDuel.vue?vue&type=script&lang=js"
import style0 from "./ModerationDuel.vue?vue&type=style&index=0&id=bd4ddd4e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports